// extracted by mini-css-extract-plugin
export default {"carouselContainer":"Carousel_carouselContainer__qYoNW","slide":"Carousel_slide__Ui7vq","image":"Carousel_image__KlSzr"};